export default {"src":"/_next/static/media/dentalOutline100_40.318e7c93.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};